import { render } from "./restyleLayout.vue?vue&type=template&id=33ed21ce&scoped=true"
import script from "./restyleLayout.vue?vue&type=script&lang=js"
export * from "./restyleLayout.vue?vue&type=script&lang=js"

import "./restyleLayout.vue?vue&type=style&index=0&id=33ed21ce&lang=scss"
import "./restyleLayout.vue?vue&type=style&index=1&id=33ed21ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ed21ce"]])

export default __exports__